import { render, staticRenderFns } from "./MobileNotSupported.vue?vue&type=template&id=a932e9c8&"
import script from "./MobileNotSupported.vue?vue&type=script&lang=js&"
export * from "./MobileNotSupported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports